import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import moment = require('moment');

@Injectable()
export class ConfigService {
    public static getFileManagementServiceUrl() {
        return `${environment.services.fileManagementService.url}/api`;
    }

    public static getPartnerServiceUrl() {
        return `${environment.services.partnerService.url}`;
    }

    public static getFileManagementServiceBaseUrl(): string {
        return `${environment.services.fileManagementService.url}/api`;
    }

    public static getInvitationServiceBaseUrl(): string {
        return `${environment.services.invitationService.url}`;
    }

    public static getPartnersFrontendUrl() {
        return `${environment.services.partnersFrontend.url}`;
    }

    public static getSSLKeyPath(): string {
        return environment.ssl.key;
    }

    public static getSSLCertPath(): string {
        return environment.ssl.cert;
    }

    public static getMaximumInvestmentLimit(): number {
        return environment.investment.maximumLimit as number;
    }

    public static getMaximumInvestmentLimitForFinx(): number {
        return environment.investment.maximumLimitForFinx as number;
    }

    public static getMinimumInvestmentLimit(): number {
        return environment.investment.minimumLimit as number;
    }

    public static getMinimumWalletBalanceForInitialPortfolio(): number {
        return environment.investment.minimumWalletBalanceForInitialPortfolio as number;
    }

    public static getDenomination(): number {
        return environment.investment.denomination as number;
    }

    public static getBaseUrl(): string {
        return `${environment.baseUrl}api`;
    }

    public static referralSchemeDateRange() {
        return environment.referralSchemeDateRange;
    }

    public getNoOfHoursForReversalExpiration(): number {
        return environment.investment.noOfHoursForReversalExpiration as number;
    }

    public getNoOfBufferHoursForReversalExpiration(): number {
        return environment.investment.noOfBufferHoursForReversalExpiration as number;
    }

    public getPartnerGroupIdOfferingEligibilityCheck(): string {
        return environment.eligibilityCheckOfferedByGroupId as string;
    }

    public baseUrl(): string {
        return `${environment.baseUrl}api/`;
    }

    public getEligibilityCheckServiceUrl() {
        return `${environment.services.eligibilityCheckService.url}`;
    }

    public getCreditAssessmentServiceUrl(): string {
        return `${environment.services.creditAssessmentService.url}`;
    }

    public getCreditBureauServiceUrl(): string {
        return `${environment.services.creditBureauService.url}`;
    }

    public getUserServiceUrl(): string {
        return `${environment.services.userService.url}`;
    }

    public getUserService_V2_Url(): string {
        return `${environment.services.userService_V2.url}`;
    }

    public getInvestmentServiceBaseUrl(): string {
        return `${environment.services.investmentService.url}`;
    }

    public getLoanService_V2_Url(): string {
        return `${environment.services.loanService_V2.url}`;
    }

    public getAccountServiceUrl(): string {
        return `${environment.services.accountService.url}`;
    }

    public getDenomination(): number {
        return ConfigService.getDenomination();
    }

    public getMinimumInvestmentLimit(): number {
        return ConfigService.getMinimumInvestmentLimit();
    }

    public getMaximumInvestmentLimit(): number {
        return ConfigService.getMaximumInvestmentLimit();
    }
    public getMaximumInvestmentLimitForFinx(): number {
        return ConfigService.getMaximumInvestmentLimitForFinx();
    }

    public getMonthlyReturnsDate(): number {
        return environment.monthlyReturnsDate as number;
    }

    public getGoogleAnalyticsTrackerId(): string {
        return environment.analytics.google.trackerId;
    }

    public getInsightAppSecValidationContent(): string {
        return environment.analytics.securityTrackers.insightAppSecValidation.content as string;
    }

    public loanApplicationServiceUrl(): string {
        return environment.services.loanApplicationService.url;
    }

    public getPaymentCollectionServiceUrl(): string {
        return environment.services.paymentCollectionService.url;
    }

    public getPaymentIssuerCodesForNetBanking(): string[] {
        return environment.paymentIssuerCodesForNetBanking as string[];
    }

    public getPayUConvenienceFeeOfDebitCard(): number {
        return environment.payUConvenienceFee.paymentMode.debitCard as number;
    }

    public getPayUConvenienceFeeOfNetBanking(): number {
        return environment.payUConvenienceFee.paymentMode.netBanking as number;
    }

    public getPayUConvenienceFeeGSTPercentage(): number {
        return environment.payUConvenienceFee.applicableGSTPercentage as number;
    }

    public getPayUNumberOfExpiryYearsForDebitCard(): number {
        return environment.payUConvenienceFee.payUNumberOfExpiryYearsForDebitCard;
    }

    public getRequiredPdcForStandardLoan(): string {
        return environment.requiredPostDatedChequeNumber.default;
    }

    public getRequiredPdcForShortTermLoan(): string {
        return environment.requiredPostDatedChequeNumber.shortTermLoan.value;
    }

    public getMaximumTenureForShortTermLoan(): number {
        return environment.requiredPostDatedChequeNumber.shortTermLoan.tenure.max;
    }

    public getEmiGracePeriodInDays(): number {
        return environment.emiGracePeriodInDays as number;
    }

    public isFinzyBoltEnabled(): boolean {
        return environment.toggles.finzyBolt as boolean;
    }

    public getCommissionPercentage(): number {
        return environment.commission.commissionInPercentage as number;
    }

    public getOldCommissionPercentage(): number {
        return environment.commission.oldCommissionInPercentage as number;
    }

    public getLenderCommissionDate(): Date {
        return moment(environment.commission.commissionDate).toDate();
    }

    public getGstPercentage(): number {
        return environment.commission.gstInPercentage as number;
    }

    public getEncryptionKey(): string {
        return environment.encryptionKey as string;
    }

    public getEnachSupportedBankNames(): string[] {
        return environment.enach.supportedBanks as string[];
    }

    public getMinimumLoanAmount(): number {
        return environment.loan.minimumLoanAmount as number;
    }

    public getMinimumLoanAmountForPartner(): number {
        return environment.loan.minimumLoanAmountForPartner as number;
    }

    public getMinimumLoanAmountForEligibilityCheckPartner(): number {
        return environment.loan.minimumLoanAmountForEligibilityCheckPartner as number;
    }

    public getLoanAmountDenomination(): number {
        return environment.loan.loanAmountDenomination as number;
    }

    public getPreApprovedLoanAmountDenomination(): number {
        return environment.loan.preApprovedLoanOffer.loanAmountDenomination as number;
    }

    public getPreApprovedLoanPartnerName(): string {
        return environment.loan.predefinedPartners.preApprovedLoanPartnerName as string;
    }

    public getPreApprovedLoanOfferMinimumLoanAmount(): number {
        return environment.loan.preApprovedLoanOffer.minimumLoanAmount as number;
    }

    public getEligibleLoanTenuresForLoanAmountRanges(): { from: number, to: number, tenure: number[] }[] {
        return environment.loan.tenure.eligibilityForLoanAmount as { from: number, to: number, tenure: number[] }[];
    }

    public getEligibleLoanTenuresForLoanAmount(loanAmount: number): number[] {
        const allTenures = environment.loan.tenure.eligibilityForLoanAmount as { from: number, to: number, tenure: number[] }[];
        const eligibleTenure = allTenures.find(tenure => loanAmount >= tenure.from && loanAmount <= tenure.to);
        return eligibleTenure ? eligibleTenure.tenure : [];
    }

    public isMultipleLoanApplyEnabled(): boolean {
        return environment.toggles.multipleLoan as boolean;
    }

    public getNpaDays(): number {
        return environment.npaDays as number;
    }

    public getRecaptchaSiteKey(): string {
        return environment.recaptchaSiteKey as string;
    }

    public getUPILimitPerDay(): number {
        return environment.UPILimitPerDay as number;
    }

    public getSubStandardAssetWriteOffPercentage(): number {
        return environment.writeOff.subStandardAsset.percentage as number;
    }

    public getLossAssetWriteOffPercentage(): number {
        return environment.writeOff.lossAsset.percentage as number;
    }

    public getLoanServiceUrl(): string {
        return environment.services.loanService.url;
    }

    public getSubstandardAssetWriteOffThresholdInDays(): number {
        return environment.writeOff.subStandardAsset.thresholdInDays as number;
    }

    public getLossAssetWriteOffThresholdInDays(): number {
        return environment.writeOff.lossAsset.thresholdInDays as number;
    }

    public getTrackerPartnerIds() {
        const trackers = environment.trackers;
        return trackers.map(tracker => {
            return tracker.partnerId;
        });
    }

    public getDownloadLSP() {
        const finzyPartners = environment.finzyPartnersLsp;
        return finzyPartners.map(finzyPartner => {
            return finzyPartner.downloadLspUrl;
        });
    }

    public getDownloadLOC() {
        const finzyPartners = environment.finzyPartnersLoc;
        return finzyPartners.map(finzyPartner => {
            return finzyPartner.downloadLocUrl;
        });
        }

    getPartnerTrackerUrlBy(partnerId: string) {
        const trackers = environment.trackers;
        return trackers.find(tracker => tracker.partnerId === partnerId).url;
    }
    featureOff(featureName: string) {
        // Read the value from the config service
        if (environment.toggles.hasOwnProperty(featureName)) {
            return !environment.toggles[featureName];
        }
        return true; // if feature not found, default to turned off
    }

    featureOn(featureName: string) {
        return !this.featureOff(featureName);
    }

    flexProFeatureOn(): boolean {
        return environment.isFlexPreLaunchActive;
    }

    public getActiveFinzyVersion(): string {
        return environment.activeFinzyVersion;
    }

    public getInitialFundAllocationMinAmount(): number {
        return environment.fundAllocationMinAmount.initial;
    }

    public getFundAllocationMinAmount(): number {
        return environment.fundAllocationMinAmount.postInitial;
    }

    public getMasterProductKey(): object {
        return environment.masterProductKey;
    }

    public getLrsYearStartFrom(): number {
        return environment.lrsYearStartFrom;
    }

    public getRestrictedDate(): string {        
        return environment.userRestrictedDate as string;    
    }

    public getPolicyFileUrlByName(fileName): string {
      return environment.policyReport[fileName];
    }

    public getFinzy2CoreLoanServiceUrl(): string {
        return environment.services.finzy2CoreLoanService.url;
    }
    
    public getMinimumIncome(): number {
        return environment.income.minimum.default;
    }

    public getMinimumSalariedIncome(): number {
        return environment.income.minimum.salaried;
    }

    public getMaximumIncome(): number {
        return environment.income.maximum.default;
    }

    public getCreditBureauServiceBaseUrl(): string {
        return `${environment.services.creditBureauService.url}`;
    }

    public getRetailerPartnersToAvoidLoginPage(): Array<string> {
        return environment.retailerPartnersToAvoidLoginPage;
    }

    public getLenderProductVariantCategoryOne(): string {
        return environment.lender.product.roi_variant_category_c1;
    }

    public getLenderProductVariantCategoryTwo(): string {
        return environment.lender.product.roi_variant_category_c2;
    }
}
